import React, {useEffect, useState} from 'react'
import ColorBox from '../../../Common/ColorBox';
import { useDispatch, useSelector } from "react-redux";
import { const_var } from '../../../../redux/reducers/reducer';
import { changeBuildingRoof, getPricingData, roofStyleChange, changeBuildingDimension, hasDoublelegBaiserail, handleLiftRequired  } from '../../../../action';
import diagonal_arrow from '../../../../assets/images/startFromScratch/diagonal.svg';

const Roofing = () => {
  
  const state = useSelector((state) => state.reducer);
  const isRoofdata = state.params.p_r_c_id;
  const dispatch = useDispatch();
  
  return (
    <>
      <section className='tab-data-padding'>
        <div className='prow'>
          <div className='prow d-flex align-item-center'>
            <span className='customize-building-note'>Customize this Building</span>
            <span className='built-size-or'>OR</span>
            <span className='start-from-scratch'><a href="https://probuiltsteel.sensei3d.com/?_gl=1*gdhewo*_ga*MTA0NzA2OTg5LjE3MTAyNTUyNTM.*_ga_6K0Q81GDH5*MTcxNDY0NTAxNS4yMS4wLjE3MTQ2NDUwMTUuMC4wLjA." target='_blank'>Start from Scratch</a><img src={diagonal_arrow} alt='diagonal-arrow'/></span>
          </div>
        </div>
      </section>
      <section className='tab-data-padding'>
        <h3 className='w-space-nowrap'>Increase Height</h3>
        <div className='d-flex'>
          <div className='pcol-4'>
            <div className='input-select form-element'>
              <label class='select'>
                <select onChange={(e) => dispatch(changeBuildingDimension({val:e.target.value, str: 'h'}))} value={state.params.p_h}>
                  {
                    const_var.buildingHeightArray.map((item) =><option value={item.value}>{item.label}</option> )
                  }
                </select>
              </label>
            </div>
          </div>
          <div className='list-options-legs'>
            {((state.const_var.hasDoublelegshow === true) && state.const_var.ConditionArr!=undefined && state.const_var.ConditionArr[state.params.p_b_t]!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s]!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray.length>1 )?
                state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray.map((data,index)=>{
                    return(
                      <div className='input-radio form-element ml-15 mb-5'>
                      <div className='input-box'>
                          <div>
                            <input 
                                  id='doublelegbaserail'
                                  className='none-check-icon' 
                                  type='radio' 
                                  
                                  value={data.name}
                                  checked={state.const_var.legstype==data.legs_type && state.params.p_e_l}
                                  name={(!const_var.isSingleBaseRail && !data.name.includes("Baserails")) ? data.name +" Baserail ": data.name}
                                  onClick={e => dispatch(hasDoublelegBaiserail(e.target.value,"center",data))}
                              />
                          </div>
                        <label for='doublelegbaserail' className='double-leg label-pointer w-space-nowrap'>{(!const_var.isSingleBaseRail && !data.name.includes("Baserails")) ? 
                            <>
                            { state.params.m_s_n == 122 && data.legs_type == "double" ?
                              `${data.name} / Double Baserail` :
                              <>{data.name?.toLowerCase()?.includes("double") ? "Double Legs"  : (data.name.includes("Baserail")) ? data.name : data.name+" Baserail " }</>
                            }
                            </>
                            :
                            <>{data.name?.toLowerCase()?.includes("double") ? "Double Legs"  : (data.name.includes("Baserail")) ? data.name : data.name+" Baserail " }</>
                          }
                        </label>
                      </div> 
                      </div> 
                  )
              })                    
              :                     
                (state.const_var.hasDoublelegshow === true && state.const_var.ConditionArr!=undefined && state.const_var.ConditionArr[state.params.p_b_t]!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s]!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray!=undefined && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray.length==1)?
                  <div className={state.const_var.hasDoublelegdisable ?'input-radio form-element ml-15 mb-5 disabled':'input-radio form-element mb-5 ml-15'}>
                    <div className='input-box'>
                      <div>
                        <input 
                          id='doublelegbaserail'
                          className='none-check-icon' 
                          type='radio' 
                          checked={state.params.p_e_l} 
                          onClick={(e) => dispatch(hasDoublelegBaiserail(e.target.value, "center"))}/>
                      </div>
                      <label for='doublelegbaserail' className='double-leg label-pointer w-space-nowrap'>{(!const_var.isSingleBaseRail && !state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name.includes("Baserails"))
                        ?
                            (state.params.m_s_n == 122 && state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].legs_type == "double"
                            ?
                              `${state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name} / Double Baserail` 
                            :
                            (
                              state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].legs_type == "double" ? 
                              "Double Legs" : (state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name.includes("Baserail")) ? state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name : state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name+" Baserail "
                            )
                            )
                        : 
                            state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].legs_type == "double" ?
                              "Double Legs" : (state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name.includes("Baserail")) ? state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name :state.const_var.ConditionArr[state.params.p_b_t][state.params.p_r_s].CustomArray[0].name + " Baserail "
                        }
                      </label>
                    </div>
                  </div>
              :null}
            {(state.const_var.a_p_d_a.side!=undefined && Object.keys(state.const_var.a_p_d_a.side).length>0 && state.const_var.a_p_d_a.side[0].lift_type!=undefined && state.const_var.a_p_d_a.side[0].lift_type!='') ?
              <div className='input-radio form-element ml-15 mb-5'>
                    <div className='input-box'>
                      <div>
                          <input
                            id='LiftRequired'
                            type='checkbox'                             
                            style={{border:'none', boxShadow:'0px 0px 0px 1px #b3b3b3'}}
                            checked={state.params.lift_type}
                            disabled={state.const_var.a_p_d_a.side.lifttype_price==0?true:false}
                            onChange={e =>
                                dispatch(handleLiftRequired(e.target.value))}
                                className='d-flex align-items-start'
                          />      
                      </div>
                      <label for='LiftRequired' className='double-leg label-pointer w-space-nowrap'>{state.const_var.a_p_d_a.side[0].lift_type}</label>
                    </div>
              </div>
            : null}
          </div>
        </div>
      </section>
      <section className='tab-data-padding'>
        <div className='prow'>
          <div className={const_var.editAPIDataByResponse.data?.request_data?.building?.roof_style == 3 ? 'pcol-5 d-none':'pcol-5'} style={{width: '200px'}}>
            <h3>Roof Style</h3>
            {/* <div className='input-select form-element'>
              <label class='select'>
                <select 
                  value={state.params.p_r_s}
                  onChange={(e) => {
                    dispatch(roofStyleChange(e.target.value));
                    dispatch(getPricingData());
                  }} 
                >
                {const_var.roof_style?.map((item) => <option value={item.roof_id}>{item.name}</option>)}        
                </select>
              </label>Vertical
            </div> */}
            {const_var.roof_style?.map((item)=>{          
             if(item.roof_id==3){ 
              return(
                <div className='input-checkbox form-element mt-15'>
                <div className='input-box' >
                  <input 
                    type='checkbox'                             
                    style={{border:'none', boxShadow:'0px 0px 0px 1px #b3b3b3'}}
                    // disabled={ const_var.roof_style?.length < 2 ? true : false }
                    value={item.roof_id}
                    checked={state.params.p_r_s== 3 ?true:false}
                    onClick={(e) => { 
                        dispatch(roofStyleChange(e.target.value, e)); 
                        dispatch(getPricingData()) 
                    }}
                    />
                  <label for={item.roof_id} className='label-pointer'>Upgrade to Vertical</label>   
                </div>   
              </div>
              )}
            })}
          </div>
          <div className='pcol-4 p-0'>
            <h3 className='w-space-nowrap'>Roof Pitch</h3>
            <div className='input-select form-element'>
              <label class='select'>
                <select onChange={(e) => dispatch(changeBuildingRoof({event: e.target.value, value: 'center'}))} value={state.params.b_r_p}>
                  {
                    Object.keys(const_var.BuildingRoofPitch)?.map((item) => <option value={item.replace("/","")}>{item}</option>)
                  }
                </select>
              </label>
            </div>
          </div>
        </div>
      </section>
      <section className='tab-data-padding'>
        {isRoofdata &&
        <div className='prow'>
          <div className='color-box-wrap'>
            <div className='p-col-12 d-flex align-item-center w-space-nowrap mt-15 mb-5'>
              <h3 className='mb-0 mt-0'>Roof Color</h3>&nbsp;
              <div class="check-color-container d-flex align-items-center">
                {'('}&nbsp;
                  <div style={{backgroundColor: state.const_var.color.find(item => item.id === state.params.p_r_c_id)?.hex_value,height:'10px', width:'10px'}} class="color-circle"></div>&nbsp;
                  <div className="color-name">
                    {state.const_var.color.find(item => item.id === state.params.p_r_c_id)?.name}
                  </div>
                {' )'}
              </div>
            </div>
            <div className='color-container'>
              {
                state.const_var.color.map((item) => {
                  return  <ColorBox colorData={item} type="roof_color"/>
                })
              }
            </div>
          </div>
        </div>}
      </section>
    </>
  )
}

export default Roofing
